import { Component, OnInit } from '@angular/core';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { GiftCardClientsModel, GiftCardContactModel, GiftCardTypesModel, GiftCardTiendaItemModel } from 'src/app/models/gifcardVirtual.model';
import { Observable } from 'rxjs';
import { FileUploadValidators, FileUploadControl } from '@iplab/ngx-file-upload';
import { map, startWith } from 'rxjs/operators';
import { TraceService } from 'src/app/services/trace.service';
import { FileService } from 'src/app/services/file.service';
import { GifcardTiendaService } from 'src/app/services/giftcardTienda.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-ordersales-tienda-step1',
  templateUrl: './ordersales-tienda-step1.component.html',
  styleUrls: ['./ordersales-tienda-step1.component.css']
})
export class OrdersalesTiendaStep1Component implements OnInit {

  id_order_sales: string;
  id_cliente: string;
  id_contacto: string;
  id_template: number;
  email_contacto: string;
  userCurrent: string;
  loading: boolean = false;
  selectClient: GiftCardClientsModel;
  datasourceSelectClient: GiftCardClientsModel[] = [];
  filteredClients: Observable<GiftCardClientsModel[]>;
  fileOrder = new FormControl(null, [FileUploadValidators.filesLimit(1), Validators.required]);
  fileCotizacion = new FormControl(null, [FileUploadValidators.filesLimit(1), Validators.required]);
  fileAdicional1 = new FormControl(null, [FileUploadValidators.filesLimit(1)]);
  fileAdicional2 = new FormControl(null, [FileUploadValidators.filesLimit(1)]);
  fileAdicional3 = new FormControl(null, [FileUploadValidators.filesLimit(1)]);
  fileUploadControl = new FileUploadControl(FileUploadValidators.filesLimit(1));

  orderSalesFormGroup: FormGroup;
  datasourceSelectContact: GiftCardContactModel[] = [];
  datasourceSelectTypes: GiftCardTypesModel[] = [];
  datasourceSelectTypesTemp: GiftCardTypesModel[] = [];

  datasourceTiendaItem: GiftCardTiendaItemModel[] = [];
  colOrderSalesTiendaItem: any[];
  disabledButtonSave: boolean = false;
  orderItem: GiftCardTiendaItemModel = new GiftCardTiendaItemModel();

  displayDialog3: boolean = false;

  constructor(private giftCardTiendaService: GifcardTiendaService,
      private giftCardService: GifcardVirtualService,
      private formBuilder: FormBuilder,
      private messageService: MessageService,
      private authService: AuthService,
      private traceService: TraceService,
      private fileService: FileService) { }

  ngOnInit() {
      this.userCurrent = this.authService.getCurrentUser();
      this.createOrderSalesForm();
      this.createColumnOrderSalesTiendaItem();
      this.populateSelectClient();
      this.filteredClients =
          this.orderSalesFormGroup.get('selClientGiftCard').valueChanges.pipe(
              startWith(''),
              map(value => typeof value === 'string' ? value : value.NRORUC_CLIENTE),
              map(value => value ? this.filterRUC(value) : this.datasourceSelectClient.slice())
          );
  }

  filterRUC(value: string): GiftCardClientsModel[] {
      const filterValue = value.toLowerCase();
      return this.datasourceSelectClient.filter(client => client.NRORUC_CLIENTE.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(client?: GiftCardClientsModel): string | undefined {
      return client ? client.NRORUC_CLIENTE : undefined;
  }

  createOrderSalesForm() {
      this.orderSalesFormGroup = this.formBuilder.group({
          selClientGiftCard: ['', Validators.required],
          selContactGiftCard: ['', Validators.required],
          txtNroRUCComprador: new FormControl({ value: '', disabled: true }, Validators.required),
          txtRazSocComprador: new FormControl({ value: '', disabled: true }, Validators.required),
          txtCorreoComprador: new FormControl({ value: '', disabled: true }, Validators.required),
          txtContacComprador: new FormControl({ value: '', disabled: true }, Validators.required),
          txtNroOrdenCompra: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]+([\-][a-zA-Z0-9]+)?')]],
          imgOrdenCompra: this.fileOrder,
          imgCotizacion: this.fileCotizacion,
          imgAdicional1: this.fileAdicional1,
          imgAdicional2: this.fileAdicional2,
          imgAdicional3: this.fileAdicional3,
          txtImpOrdenCompra: ['', [Validators.required, Validators.pattern('[0-9]+([\.,][0-9]+)?')]],
          txtObservaciones: ['']
      });
  }

  createColumnOrderSalesTiendaItem(){
    this.colOrderSalesTiendaItem = [
        { field: 'SKU', header: 'SKU', style: '20%' },
        { field: 'DESCRIPCION', header: 'Descripción', style: '40%' },
        { field: 'CANTIDAD', header: 'Cantidad', style: '10%' },
        { field: 'PRECIOCIGV', header: 'Precio Con IGV', style: '10%' },
        { field: 'PRECIOSIGV', header: 'Precio Sin IGV', style: '10%' },
        { field: 'SUBTOTAL', header: 'Sub Total', style: '10%' }
      ];
  }

  saveOrderSales() {
      if (this.orderSalesFormGroup.valid) {

          this.loading = true;

          if (Number(this.orderSalesFormGroup.get('txtImpOrdenCompra').value) <= 0) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ingrese un monto válido.' });
              this.loading = false;
          }
          else if (!this.fileOrder.value) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo orden de compra.' });
              this.loading = false;
          }
          else if (!this.fileOrder.valid) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen de la orden de compra' });
              this.loading = false;
          }
          else if (!this.fileCotizacion.value) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo cotización.' });
              this.loading = false;
          }
          else if (!this.fileCotizacion.valid) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen de la cotización' });
              this.loading = false;
          }
          else if (!this.fileAdicional1.valid) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen o pdf para el archivo adicional 1' });
              this.loading = false;
          }
          else if (!this.fileAdicional2.valid) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen o pdf para el archivo adicional 2' });
              this.loading = false;
          }
          else if (!this.fileAdicional3.valid) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo tipo imagen o pdf para el archivo adicional 3' });
              this.loading = false;
          }
          else if ((this.fileAdicional1.value || this.fileAdicional2.value || this.fileAdicional3.value) && !this.observaciones.value) {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe registrar el motivo por que se adjunta un o más documentos adicionales.' });
              this.loading = false;
          }
          else if (this.datasourceTiendaItem.length < 1){
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe cargar la información de items de la orden de compra.' });
            this.loading = false;
          }
          else {
              let orderSales = {
                  "p_id_cliente_gift_card": this.id_cliente,
                  "p_id_contact_gift_card": this.id_contacto,
                  "p_nro_orden_compra": this.nro_orden_compra2.value,
                  "p_imp_orden_compra": this.importe_orden_compra2.value,
                  "p_observaciones": this.observaciones.value,
                  "p_creationuser": this.userCurrent
              };

              console.log(orderSales);
              this.giftCardTiendaService.CreateOrderSalesTienda(orderSales).subscribe(
                  (response) => {
                      let json = response;
                      this.id_order_sales = json.NEW_ID_ORDER_SALES;
                      this.updateImageOrder();
                      this.createOrderSalesTiendaItem();
                      this.disabledButtonSave = true;
                      this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'La orden de compra se registro correctamente.' });
                  },
                  (error) => {
                      console.log(error);
                      this.loading = false;
                      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al registrar la orden de compra.' });
                  }
              )
          }
      }
      else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ingrese todos los campos obligatorios.' });
      }
  }

  createOrderSalesTiendaItem(){
    this.datasourceTiendaItem.forEach(row => {
        let item = {
            "p_id_order_gift_card": this.id_order_sales,
            "p_id_cliente_gift_card": this.id_cliente,
            "p_id_contact_gift_card": this.id_contacto,
            "p_sku": row.SKU,
            "p_description": row.DESCRIPCION,
            "p_cantidad": row.CANTIDAD,
            "p_preciocigv": row.PRECIOCIGV,
            "p_preciosigv": row.PRECIOSIGV,
            "p_subtotal": row.SUBTOTAL,
            "p_creationuser": this.userCurrent
        }
    
        this.giftCardTiendaService.CreateOrderSalesTiendaItem(item).subscribe(
            (response) => {              
            },
            (error) => {
                console.log(error);
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al registrar items de la orden de compra.' });
            }
        )
    });    
  }

  onUpload() {
    if (this.fileUploadControl.valid && this.fileUploadControl.value.length) {
      let workBook = null;
      let jsonData = null;
      const reader = new FileReader();
      const file = this.fileUploadControl.value[0];
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        console.log(jsonData.data);
        this.populateTablaOrderSalesTiendaItem(jsonData);
      }
      reader.readAsBinaryString(file);
      this.fileUploadControl.clear();
      this.displayDialog3 = false;
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo excel de información adicional.' });
    }
  }

  populateTablaOrderSalesTiendaItem(jsonData){
    for (let key in jsonData.data){        
        this.orderItem = new GiftCardTiendaItemModel();
        this.orderItem.SKU = jsonData.data[key].SKU;
        this.orderItem.DESCRIPCION = jsonData.data[key].DESCRIPCION;
        this.orderItem.CANTIDAD = jsonData.data[key].CANTIDAD;
        this.orderItem.PRECIOCIGV = jsonData.data[key].PRECIOCIGV;
        this.orderItem.PRECIOSIGV = jsonData.data[key].PRECIOSIGV;
        this.orderItem.SUBTOTAL = jsonData.data[key].SUBTOTAL;
        this.datasourceTiendaItem.push(this.orderItem);
    }
  }

  updateImageOrder() {
      let params = new FormData();
      params.append('p_id_order_gift_card', this.id_order_sales);
      params.append('p_type_order_sales', this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA);
      params.append('p_type_file', this.fileService.FILE_ORDER);
      params.append('p_creationuser', this.userCurrent);
      params.append('file', this.fileOrder.value[0]);        
      this.fileService.CreateGiftCardOrderSalesTiendaFile(params).subscribe(
          (response) => {
              this.updateImageCotizacion();
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo de la orden de compra cargada correctamente.' });
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar la imagen de la orden de compra.' });
          }
      )
  }

  updateImageCotizacion() {
      let params = new FormData();
      params.append('p_id_order_gift_card', this.id_order_sales);
      params.append('p_type_order_sales', this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA);
      params.append('p_type_file', this.fileService.FILE_COTIZ);
      params.append('p_creationuser', this.userCurrent);
      params.append('file', this.fileCotizacion.value[0]);
      this.fileService.CreateGiftCardOrderSalesTiendaFile(params).subscribe(
          (response) => {
              if (this.fileAdicional1.value) {
                  this.updateImageAdicional1();
              }
              if (this.fileAdicional2.value) {
                  this.updateImageAdicional2();
              }
              if (this.fileAdicional3.value) {
                  this.updateImageAdicional3();
              }
              this.createOrderSalesTrace();
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo de la cotización cargada correctamente.' });
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar la imagen de la cotización.' });
          }
      )
  }

  updateImageAdicional1() {
      let params = new FormData();
      params.append('p_id_order_gift_card', this.id_order_sales);
      params.append('p_type_order_sales', this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA);
      params.append('p_type_file', this.fileService.FILE_ADIC1);
      params.append('p_creationuser', this.userCurrent);
      params.append('file', this.fileAdicional1.value[0]);
      this.fileService.CreateGiftCardOrderSalesTiendaFile(params).subscribe(
          (response) => {
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo adicional 1 cargado correctamente.' });
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el archivo adicional 1.' });
          }
      )
  }

  updateImageAdicional2() {
      let params = new FormData();
      params.append('p_id_order_gift_card', this.id_order_sales);
      params.append('p_type_order_sales', this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA);
      params.append('p_type_file', this.fileService.FILE_ADIC2);
      params.append('p_creationuser', this.userCurrent);
      params.append('file', this.fileAdicional2.value[0]);
      this.fileService.CreateGiftCardOrderSalesTiendaFile(params).subscribe(
          (response) => {
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo adicional 2 cargado correctamente.' });
          },
          (error) => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el archivo adicional 2.' });
          }
      )
  }

  updateImageAdicional3() {
      let params = new FormData();
      params.append('p_id_order_gift_card', this.id_order_sales);
      params.append('p_type_order_sales', this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA);
      params.append('p_type_file', this.fileService.FILE_ADIC3);
      params.append('p_creationuser', this.userCurrent);
      params.append('file', this.fileAdicional3.value[0]);
      this.fileService.CreateGiftCardOrderSalesTiendaFile(params).subscribe(
          (response) => {
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo adicional 3 cargado correctamente.' });
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el archivo adicional 3.' });
          }
      )
  }

  populateSelectClient() {
      this.giftCardService.GetGiftCardClients().subscribe(
          (response: GiftCardClientsModel[]) => {
              this.datasourceSelectClient = response;
          },
          (error) => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar clientes.' });
          }
      )
  }

  populateSelectContact() {
      let client = {
          "p_id_cliente_gift_card": this.id_cliente
      };
      this.giftCardService.GetContactByClient(client).subscribe(
          (response: GiftCardContactModel[]) => {
              this.datasourceSelectContact = response;
          },
          (error) => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar contactos.' });
          }
      )
  }

  createOrderSalesTrace() {
      let params = {
          "p_id_order_gift_card": this.id_order_sales,
          "p_type_order_sales": this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA,
          "p_action": 'ACTIVADO',
          "p_observation": this.observaciones.value ? this.observaciones.value : 'Activado Correctamente.',
          "p_creationuser": this.userCurrent
      };
      this.traceService.CreateGiftCardOrderSalesTrace(params).subscribe(
          (response) => {
              this.loading = false;
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Trace registrado correctamente.' });
          },
          (error) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
          }
      )
  }

  onSelectClient(client) {
      if (client) {
          this.id_cliente = client.ID_CLIENTE.toString();
          this.orderSalesFormGroup.get('txtNroRUCComprador').setValue(client.NRORUC_CLIENTE);
          this.orderSalesFormGroup.get('txtRazSocComprador').setValue(client.RAZSOC_CLIENTE);
          this.populateSelectContact();
      }
  }

  onSelectContact() {
      this.id_contacto = this.orderSalesFormGroup.get('selContactGiftCard').value;
      for (let i = 0; i < this.datasourceSelectContact.length; i++) {
          if (this.datasourceSelectContact[i].ID_CONTACT == Number(this.id_contacto)) {
              this.orderSalesFormGroup.get('txtContacComprador').setValue(this.datasourceSelectContact[i].NOMBRE_CONTACTO);
              this.orderSalesFormGroup.get('txtCorreoComprador').setValue(this.datasourceSelectContact[i].CORREO_CONTACTO);
              this.email_contacto = this.datasourceSelectContact[i].CORREO_CONTACTO;
              break;
          }
      }
  }

  onShowDialog() {
    this.displayDialog3 = true;
  }

  get cliente_gif2() {
      return this.orderSalesFormGroup.get('selClientGiftCard');
  }

  get contact_gif2() {
      return this.orderSalesFormGroup.get('selContactGiftCard');
  }

  get ruc_comprador2() {
      return this.orderSalesFormGroup.get('txtNroRUCComprador');
  }

  get razon_comprador2() {
      return this.orderSalesFormGroup.get('txtRazSocComprador');
  }

  get correo_comprador2() {
      return this.orderSalesFormGroup.get('txtCorreoComprador');
  }

  get contacto_comprador2() {
      return this.orderSalesFormGroup.get('txtContacComprador');
  }

  get nro_orden_compra2() {
      return this.orderSalesFormGroup.get('txtNroOrdenCompra');
  }

  get importe_orden_compra2() {
      return this.orderSalesFormGroup.get('txtImpOrdenCompra');
  }

  get observaciones() {
      return this.orderSalesFormGroup.get('txtObservaciones');
  }

  get imgOrder() {
      return this.orderSalesFormGroup.get('imgOrdenCompra');
  }

  get imgCotizacion() {
      return this.orderSalesFormGroup.get('imgCotizacion');
  }

  get imgAdicional1() {
      return this.orderSalesFormGroup.get('imgAdicional1');
  }

  get imgAdicional2() {
      return this.orderSalesFormGroup.get('imgAdicional2');
  }

  get imgAdicional3() {
      return this.orderSalesFormGroup.get('imgAdicional3');
  }
}